var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.3149 13.2265C11.0057 12.9173 11.0057 12.416 11.3149 12.1069C11.624 11.7977 12.1253 11.7977 12.4345 12.1069L15.6011 15.2735C15.9103 15.5827 15.9103 16.084 15.6011 16.3931C15.292 16.7023 14.7907 16.7023 14.4815 16.3931L11.3149 13.2265Z",
    fill: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16699 8.70835C3.16699 11.7689 5.64808 14.25 8.70866 14.25C11.7692 14.25 14.2503 11.7689 14.2503 8.70835C14.2503 5.64778 11.7692 3.16669 8.70866 3.16669C5.64808 3.16669 3.16699 5.64778 3.16699 8.70835ZM12.667 8.70836C12.667 10.8945 10.8948 12.6667 8.70866 12.6667C6.52253 12.6667 4.75033 10.8945 4.75033 8.70836C4.75033 6.52223 6.52253 4.75002 8.70866 4.75002C10.8948 4.75002 12.667 6.52223 12.667 8.70836Z",
    fill: "#DADADA"
  })));
}

export default SvgSearchIcon;